export const resetPasswordRoutePath = '/reset-password/:token';
